import { db } from "@/firebase"
import { collection, doc, getDoc, setDoc, query, orderBy, limit, getDocs,  where, startAfter, deleteDoc } from "firebase/firestore"


const BlogState = {
  answerNodeBlogs: [],
  blogCache: {},
  adminBlogs: [],
  blogTopics: {}, // <topic>: [blog_id, blog_id]
  topicOrder: [],
  allBlogs: [],
}

const BlogMutations = {
  cacheBlog(state, payload){
    if (typeof(state.blogCache[payload.header.id]) !== "undefined"){
      state.blogCache[payload.header.id] = Object.assign(state.blogCache[payload.header.id], payload)
    }else{
      state.blogCache[payload.header.id] = payload
    }
  },

  deleteBlog(state, blog_id){
    delete state.blogCache[blog_id]
    let i = state.allBlogs.indexOf(blog_id) 
    if (i > 0){
      state.allBlogs.splice(i, 1)
    }
    let e = state.adminBlogs.indexOf(blog_id) 
    if (e > 0){
      state.adminBlogs.splice(e, 1)
    }
  },
  addAnswerNodeBlog(state, payload){
    state.answerNodeBlogs.push(payload)
  },
  addAdminBlog(state, payload){
    state.adminBlogs.push(payload)
  },
  addBlogToAll(state, payload){
    state.allBlogs.push(payload)
  },
  removeBlog(state, payload){
    if (state.adminBlogs.indexOf(payload) >= 0){
      state.adminBlogs = state.adminBlogs.splice(state.adminBlogs.indexOf(payload), 1)
    }
    if (state.answerNodeBlogs.indexOf(payload) >= 0){
      state.answerNodeBlogs = state.answerNodeBlogs.splice(state.answerNodeBlogs.indexOf(payload), 1)
    }
    if (typeof(state.blogCache[payload]) !== "undefined"){
      delete state.blogCache[payload]
    }
  },
  addTopicBlogs(state, payload){
    let {topic, blog_ids} = payload
    if (!state.blogTopics[topic]) state.blogTopics[topic] = [];
    state.blogTopics[topic] = [...state.blogTopics[topic], ...blog_ids]
    if(state.topicOrder.indexOf(topic) < 0) state.topicOrder.push(topic) 
  },
  setAllBlogsMeta(state, data){
    
    state.lazyMeta.allBlogs = Object.assign(state.lazyMeta.allBlogs, data);
  },
  setTopicsLastVisible(state, topic, lastVisible){
    state.lazyMeta.blogTopics[topic] = {lastVisible: lastVisible};
  }
}

const BlogActions = {
  loadBlogsFromAnswer({commit, state}, answer){
    if (!answer) return
    if (answer.blogs?.length){
      for(let id of answer.blogs){
        if (state.blogCache[id]){
          commit('addAnswerNodeBlog', id)
          continue
        }
        getDoc(doc(db, "blogs", id))
        .then((blogRef) => {
          commit('cacheBlog', {header: blogRef.data()})
          commit('addAnswerNodeBlog', id)
          console.log("loadBlogsForAnswer")
        })
        .catch((reason) => {
          console.log("could not load blog",reason)
        })
      }
    }
  },
  lazyLoadAdminBlogs({commit, state}){
    // if(!state.lazyMeta.adminBlogs.nextPageToken){
      commit('setState',{adminBlogs: []})
      getDocs(query(collection(db, "blogs"),orderBy("id"),limit(50))).then((results) => {
        results.forEach((blogRef) => {
          commit('cacheBlog', {header: blogRef.data()})
          commit('addAdminBlog', blogRef.id)
        })
      })
    // }
  },
  lazyLoadAllBlogs({commit, state}){
    if (state.cachedState.allBlogs.length){
      if (!state.allBlogs.length){
        commit('setState', {allBlogs: state.cachedState.allBlogs})
        return
      }
      
    }
    
    if(state.lazyMeta.allBlogs.loading || state.lazyMeta.allBlogs.done) return
    commit('setAllBlogsMeta', {loading: true})
    let q = query(collection(db, "blogs"),orderBy("updatedAt", 'asc'),limit(10))
    
    if (state.lazyMeta.allBlogs.lastVisible){
      q = query(collection(db, "blogs"), orderBy('updatedAt', 'asc'), limit(10), startAfter(state.lazyMeta.allBlogs.lastVisible))
    }
    getDocs(q).then((snapshots) => {
      
      let lastVisible = snapshots.docs[snapshots.docs.length - 1]
      commit('setAllBlogsMeta', {lastVisible, done: snapshots.docs.length == 0, loading: false})
      
      snapshots.forEach((blogRef) => {
        commit('cacheBlog', {header: blogRef.data()})
        commit('addBlogToAll', blogRef.id)
      })
    }).catch((err) => {
      console.log("could not get all blogs", err)
    })
    
  },
  async lazyLoadTopic({commit, state}, topic){
    if(state.cachedState.blogTopics[topic]){
      if (!state.blogTopics[topic]){
        commit('addTopicBlogs', {topic, blog_ids: state.cachedState.blogTopics[topic]})
        return
      }
      if (state.safeMode) return      
    }
    var blogQuery = null
    if (state.lazyMeta.blogTopics[topic]){
      if(!state.lazyMeta.blogTopics[topic].lastVisible) return
      blogQuery = query(collection(db, "blogs"), where("tags", "array-contains", topic), limit(3), startAfter(state.lazyMeta.blogTopics[topic].lastVisible))
    }else{
      blogQuery = query(collection(db, "blogs"), where("tags", "array-contains", topic), limit(3))
    }
    
    const snapshots = await getDocs(blogQuery)
    if (!snapshots.docs.length){
      commit('setTopicsLazyMeta', topic, false)
      return
    }

    let topicBlogs = []
    let lastVisible = snapshots.docs[snapshots.docs.length - 1]
    snapshots.docs.forEach((snapshot) => {
      let header = snapshot.data()
      commit('cacheBlog', {header: header})
      topicBlogs.push(header.id)
    })
    commit('addTopicBlogs', {topic, blog_ids: topicBlogs})
    commit('setTopicsLastVisible', {topic, lastVisible})
  },


  
  async loadBlog({commit, state}, blog_id){
    let blog = {}
    
    if (typeof(state.blogCache[blog_id]) === "undefined"){
      let res = await getDoc(doc(db, "blogs", blog_id))
      blog.header = res.data()
      console.log('loadBlog pt 1',blog)
    }else{ 
      blog = state.blogCache[blog_id]
    }
    
    if(typeof(blog.body) === "undefined"){
      let res = await getDoc(doc(db, "blogs", blog_id, 'body', blog_id))
      blog.body = res.data()
      console.log('loadBlog pt 2',blog)
    }

    if (typeof(blog.header?.brief) === "undefined"){
      let res = await getDoc(doc(db, 'blogs', blog_id, 'brief', blog_id))
      blog.header.brief = res.data()
      console.log('loadBlog pt 3',blog)
    }

    commit("cacheBlog", blog)
  },
  // eslint-disable-next-line
  deleteBlog({commit, state}, blog_id){
    if(confirm("are you sure you want to delete? ")){
      deleteDoc(doc(collection(db, "blogs"), blog_id, "body", blog_id)).then()
      deleteDoc(doc(collection(db, "blogs"), blog_id, "brief", blog_id)).then()
      deleteDoc(doc(collection(db, "blogs"), blog_id)).then()
      commit("deleteBlog", blog_id)
    }
    return
  },
  async loadBlogHeaders({commit, state}, blog_ids){
    for(let blog_id of blog_ids){
      try{
        if (state.blogCache[blog_id]) continue
        let headerDoc = await getDoc(doc(db, "blogs", blog_id))
        let header = headerDoc.data()
        commit('cacheBlog', {header: header})
      }catch{
        console.log("could not get blog header");
        continue
      }
    }
  },
  async saveBlog({commit, state}, {blog_id, blogData}){
    try {
      const { header, body, brief } = blogData
      
      if (header) {
        await setDoc(doc(db, "blogs", blog_id), header)
      }
      
      if (body) {
        await setDoc(doc(db, "blogs", blog_id, "body", blog_id), body)
      }
      
      if (brief) {
        await setDoc(doc(db, "blogs", blog_id, "brief", blog_id), brief)
      }
      
      commit('cacheBlog', blogData)
      console.log("Blog saved successfully")
      return true
    } catch (error) {
      console.error("Error saving blog:", error)
      throw error
    }
  }
}

const BlogGetters = {

  topicOptions: (state) => () => {
    return state.topics.reduce((prev, current) => {
      if (state.topicOrder.indexOf(current) < 0)
        prev.push(current)
      return prev
    }, [])
    // .sort((a,b) => a.length - b.length)
  }

}

export {BlogState, BlogActions, BlogGetters, BlogMutations}




